const hoursFormatted = (index: number) => [
  `${index.toString().padStart(2, '0')}:00`,
  `${index.toString().padStart(2, '0')}:15`,
  `${index.toString().padStart(2, '0')}:30`,
  `${index.toString().padStart(2, '0')}:45`,
];
const newHoursValue = [];

for (let index = 0; index < 24; index += 1) {
  const options = hoursFormatted(index).map(hour => ({
    selected: index === 0,
    label: hour,
    value: hour,
  }));

  newHoursValue.push(options);
}

export default newHoursValue.flat();
